var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is_cart_view)?_c('div',{staticClass:"btn-remove-article",on:{"click":function($event){$event.stopPropagation();return _vm.removeArticle($event)}}},[_c('i',{staticClass:"bi bi-x-lg"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }